import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core";
import Switch from "@material-ui/core/Switch";

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 34,
    height: 18,
    padding: 0,
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#006FD1",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#006FD1",
    },
  },
  thumb: {
    width: 16,
    height: 16,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: "#707070",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

export default function CustomSwitch({ onChange, value = false }) {
  const [checkValue, setCheckValue] = useState(value);

  const handleChange = () => {
    setCheckValue(!checkValue);
    onChange(!checkValue);
  };

  return (
    <IOSSwitch
      checked={checkValue}
      value={checkValue}
      onChange={handleChange}
      name="checked"
    />
  );
}
